import styled from "styled-components";
import { RowGrid } from "./RowGrid";
import { OverflowContainerVertical } from "../PackageExports";
export const ScrollingRowGrid = styled(RowGrid) `
  ${OverflowContainerVertical};
`;
